<app-download-app-banner *ngIf="closePopupVar !== 'none' && !isSipSubscribed" class="w-100" [config]="{v: 2, title: 'Manage Your Monthly Donations Hassle-Free!'}"></app-download-app-banner>

<div class="ended-fundraiser-sip-dialog" [ngStyle]="{'display':closePopupVar}" [ngClass]="{'download-app-AB': !isSipSubscribed}">
  <div class="title">
    <i class="material-icons">warning_amber</i> This fundraiser is not accepting funds anymore
  </div>

  <div *ngIf="vars?.fundraiser?.isDonated" class="summary">
    <div class="summary-title">Fundraiser Summary</div>
    <div class="content">
      <div class="content-item">
        <span><app-currency-icon [currency]="currency"></app-currency-icon>{{fundraiser?.raised?.raised | inrFormat:currency}}</span>
        <p>Funds Raised</p>
      </div>
      <div class="content-item">
        <img loading="lazy" class="donors-img" [attr.data-src]="supporterImg" />
        <p>{{fundraiser?.raised?.backers | inrFormat:currency}} Supporters</p>
      </div>
      <div class="content-item">
        <span>1</span>
        <p>Life impacted</p>
      </div>
    </div>
  </div>

  <div class="monthly-card">
    <app-sip-card-assured [supporterImg]="supporterImg" [redirectTo]="'/new/sip'" [redirectWitQuery]="{ utm_term: 'endedfundraiser'}"></app-sip-card-assured>
  </div>

  <button class="continue-btn" (click)="closePopup()" mat-button>Continue to the fundraiser</button>
</div>